module.exports = __webpack_public_path__ + "black1.7f27bb3a.png";